import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RadioOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const RadioOptionAgentic = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;


export const RadioOptionContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

export const RadioOptionLabel = styled.div`
  display: flex;
  align-items: center;
`;

export const DocumentInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  margin-left: 28px;
  width: calc(100% - 28px);
`;

export const HumanSelectWrapper = styled.div`
  margin-left: 28px;
  width: calc(100% - 28px);
`;

export const DescriptionText = styled.div`
  margin-left: 28px;
`;
